export let TransactionSide;

(function (TransactionSide) {
  TransactionSide["Buyer"] = "buyer";
  TransactionSide["Seller"] = "seller";
})(TransactionSide || (TransactionSide = {}));

export let TransactionStatus;

(function (TransactionStatus) {
  TransactionStatus[TransactionStatus["DebitProcessed"] = 230] = "DebitProcessed";
  TransactionStatus[TransactionStatus["StatusNew"] = 1] = "StatusNew";
  TransactionStatus[TransactionStatus["StatusEstimated"] = 100] = "StatusEstimated";
  TransactionStatus[TransactionStatus["StatusDebitFailed"] = 220] = "StatusDebitFailed";
})(TransactionStatus || (TransactionStatus = {}));

export let ApplicableTransactionAction;

(function (ApplicableTransactionAction) {
  ApplicableTransactionAction["Offer"] = "offer";
  ApplicableTransactionAction["Buy"] = "buy";
  ApplicableTransactionAction["RequestOffer"] = "request_offer";
  ApplicableTransactionAction["Transfer"] = "transfer";
  ApplicableTransactionAction["Reserve"] = "reserve";
  ApplicableTransactionAction["WaitingForShipment"] = "waiting_for_shipment";
  ApplicableTransactionAction["LeaveFeedback"] = "feedback";
})(ApplicableTransactionAction || (ApplicableTransactionAction = {}));

export let AdditionalTransactionAction;

(function (AdditionalTransactionAction) {
  AdditionalTransactionAction["MarkAsSold"] = "mark_as_sold";
  AdditionalTransactionAction["MarkAsReceived"] = "mark_as_received";
  AdditionalTransactionAction["CanMarkAsReceived"] = "can_mark_as_received";
  AdditionalTransactionAction["Bundle"] = "bundle";
  AdditionalTransactionAction["UsePayments"] = "use_payments";
  AdditionalTransactionAction["DeleteConversation"] = "delete_thread";
  AdditionalTransactionAction["Cancel"] = "cancel";
  AdditionalTransactionAction["ConfirmShipmentInstructions"] = "confirm_shipment_instructions";
})(AdditionalTransactionAction || (AdditionalTransactionAction = {}));

export let TransactionUserStatus;

(function (TransactionUserStatus) {
  TransactionUserStatus["Failed"] = "failed";
  TransactionUserStatus["NeedsAction"] = "needs_action";
  TransactionUserStatus["Waiting"] = "waiting";
  TransactionUserStatus["Completed"] = "completed";
})(TransactionUserStatus || (TransactionUserStatus = {}));